import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import TextField from '@mui/material/TextField';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useMemo } from 'react';

export default function DateTimeSelector({
  themeMode,
  minForecastPubTime,
  forecastPubTime,
  handleForecastPubTimeChange
}) {
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode
        }
      }),
    [themeMode]
  );
  return (
    <div
      className='datetimeselector'
      title='Note: currently only updates the forecast plot'
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <DateTimePicker
            renderInput={(props) => (
              <TextField size='small' margin='dense' {...props} />
            )}
            value={forecastPubTime}
            label='Select Forecast Publication Time'
            onChange={(newValue) => {
              handleForecastPubTimeChange(newValue);
            }}
            minDateTime={minForecastPubTime}
            maxDateTime={new Date(Date.now() + 60000)} //Adding 1 minute to the current time
            inputFormat='MM/dd/yyyy hh:00 a'
            views={['year', 'month', 'day', 'hours']}
          />
        </ThemeProvider>
      </LocalizationProvider>
    </div>
  );
}
